import React from 'react';

const ActiveRequestForMobile = ({ data }) => {
  const cardData = data?.[0] || {}; // Use the first element of the data array or an empty object if data is undefined

  return (
    <div className="card">
      <div className="card-body pb-0">
        <ul className="list-group list-group-flush">
          <li className="list-group-item d-flex px-0 justify-content-between">
            <strong className='text-secondary'>ID</strong>
            <span className="mb-0">{cardData.hkrq_id || 'N/A'}</span>
          </li>
          <li className="list-group-item d-flex px-0 justify-content-between">
            <strong className='text-secondary'>Request Summary</strong>
            <span className="mb-0">{cardData.request_summary || 'N/A'}</span>
          </li>
          <li className="list-group-item d-flex px-0 justify-content-between">
            <strong className='text-secondary'>Tracking Level</strong>
            <span className="mb-0">{cardData.tracking_level || 'N/A'}</span>
          </li>
          <li className="list-group-item d-flex px-0 justify-content-between">
            <strong className='text-secondary'>Status</strong>
            <span className="mb-0 badge badge-secondary">{cardData.status_val || 'N/A'}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};


export default ActiveRequestForMobile;
